/* Keep mobile pagination compact without changing native media indexes or filters. */
if (!customElements.get('smd-gallery-dots')) {
  customElements.define('smd-gallery-dots', class extends HTMLElement {
    async connectedCallback() {
      await customElements.whenDefined('page-dots');
      if (!this.isConnected || this.observer) return;
      const dots = this.querySelector('page-dots');
      if (!dots) return;
      this.dots = dots;
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(dots, {subtree:true, attributes:true, attributeFilter:['aria-current','hidden']});
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }
    update() {
      const buttons = [...this.dots.querySelectorAll(':scope > button')];
      const available = buttons.filter(button => !button.hidden);
      const selected = Math.max(0, available.findIndex(button => button.getAttribute('aria-current') === 'true'));
      const count = Math.min(7, available.length);
      const start = Math.max(0, Math.min(selected - 3, available.length - count));
      const windowButtons = available.slice(start, start + count);
      buttons.forEach(button => {
        button.toggleAttribute('data-smd-dot-outside', !windowButtons.includes(button));
        const edge = (button === windowButtons[0] && start > 0) ||
          (button === windowButtons[count - 1] && start + count < available.length);
        button.toggleAttribute('data-smd-dot-edge', edge);
      });
      this.toggleAttribute('data-single', available.length < 2);
      this.setAttribute('data-ready', '');
    }
  });
}
